<pcg-resizable-widget>
    <span widget-title>
        EXPIRING MEDICATIONS (30 days)
        <fa-icon 
            [icon]="faArrowUpRIghtFromSquare" 
            style="cursor:pointer"
            (click)="goToExpirationReport()"
            ngbTooltip="Go to Expiration Report" 
        ></fa-icon>
    </span>
    <div class="h-100" widget-body>
        @if (isLoading) {
            <div class="mt-2 pb-1 text-center">
                <span 
                    class="spinner-border spinner-border-sm align-middle mr-1" 
                    role="status" 
                    aria-hidden="true"
                ></span>
                Finding Expiring Medications...
            </div>
        } @else {
            @for (expiringMed of expiringMeds; track expiringMed.inventoryLotExpId) {
                <pcg-link 
                    class="notif-item"
                    [href]="goToLotExp(expiringMed)"
                >
                    <div class="notif-body">
                        <div class="notif-title">{{ expiringMed.inventoryName }}</div>
                        <div class="notif-desc">{{ expiringMed.productName }}</div>
                    </div>
                    <div class="notif-right">
                        <div class="notif-time">{{ expiringMed.expDate | date : 'MM/dd/yyyy' }}</div>
                    </div>
                </pcg-link>
            } @empty {
                <div class="text-center text-muted py-3">No expiring medications to display</div>
            }
        }
    </div>
</pcg-resizable-widget>